import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { message } from 'antd';
import baseuri from '../../baseuri';

export const getbulkSenderList = createAsyncThunk(
	'/bulkSender/getbulkSenderList',
	async (params: any) => {
		const res = await baseuri.get('/admin/master/sender', {
			params: { ...params },
		});
		return res.data.data;
	}
);

export const getSingleBulkSender = createAsyncThunk(
	'/bulkSender/getSingleBulkSender',
	async (params: any) => {
		const res = await baseuri.get(`/admin/master/bulk_sending`, {
			params: { ...params },
		});

		return res.data.data;
	}
);

export const distributeBulkSenderFund = createAsyncThunk(
	'bulkSender/distributeBulkSenderFund',
	async (data: any) => {
		try {
			const res = await baseuri.post(
				'/admin/master/sender/distribute/fund',
				data
			);

			message.success('Bulk sender job created successfully');
			return res.data.data;
		} catch (e: any) {
			message.error(e.response.data.message);
			return false;
		}
	}
);

export const distributeCronBulkSenderFund = createAsyncThunk(
	'bulkSender/distributeCronBulkSenderFund',
	async (data: any) => {
		try {
			const res = await baseuri.post(
				'/admin/master/sender/cron/distribute/bulk/fund',
				data
			);

			message.success('Bulk sender cron job created successfully');
			return res.data.data;
		} catch (e: any) {
			// console.log('e', e);
			message.error(e.response.data.message);
			return false;
		}
	}
);

export const createBulkSender = createAsyncThunk(
	'bulkSender/createBulkSender',
	async ({ params, payload }: { params: any; payload: any }) => {
		try {
			const res = await baseuri.post(
				`/admin/master/sender/create/list`,
				payload,
				{
					params: { ...params },
				}
			);

			message.success('Bulk sender created successfully');
			return res.data.data;
		} catch (e: any) {
			message.error(e.response.data.message);
			return false;
		}
	}
);

export const createInstantFund = createAsyncThunk(
	'bulkSender/createInstantFund',
	async (data: any) => {
		try {
			const res = await baseuri.post(`/admin/master/sender/instant/fund`, data);
			message.success('Instant payment created successfully');
			return res.data.data;
		} catch (e: any) {
			message.error(e.response.data.message);
			return false;
		}
	}
);

const bulkSenderRx = createSlice({
	name: 'bulkSender',
	initialState: {
		bulkSenderList: {
			currencies: [],
			jobs: [],
			moneyBook: [],
		},
		singleBulkSender: {
			jobs: [],
			profile: {
				createdAt: '',
				csv_text: null,
				currency: {
					name: '',
					symbol: '',
				},
				funder: { email: '' },
				fundingTransactionStatementID: '',
				lastUpdatedBy: '',
				status: '',
				title: '',
				updatedAt: '',
				_id: '',
			},
			total_amount: [{ total_pay_amount: 0 }],
			total_user: 0,
		},
	},
	reducers: {},
	extraReducers: (builder) =>
		builder
			.addCase(getbulkSenderList.fulfilled, (store, action) => {
				const state = store;
				state.bulkSenderList = action.payload;
			})
			.addCase(getSingleBulkSender.fulfilled, (store, action) => {
				const state = store;
				state.singleBulkSender = action.payload;
			}),
});

export default bulkSenderRx.reducer;
